<template>
  <v-hover v-if="item.if != undefined ? item.if : true" v-slot="{ hover }">
    <div
      class="menu__item f14 d-flex gap-2 justify-space-between py-3 px-4"
      :class="{ 'primary white--text': hover, pointer: !item.loading  }"
      @click="item.click ? item.click() : undefined"
    >
      {{ item.title }}
      <BaseIcon :icon="`${item.icon}`" />
    </div>
  </v-hover>
</template>

<script>
export default {
  name: 'ChatContextMenuItem',
  props: {
    item: Object,
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.menu__item {
  transition: 0.3s;
  display: grid;
  grid-template-columns: 1fr max-content;
  align-items: center;
  gap: 4px;
  :deep()svg {
    height: 15px;
    width: auto;
    path {
      fill: var(--v-secondary-darken2);
    }
  }
  &:hover {
    :deep()svg {
      path {
        fill: white;
      }
    }
  }
}
</style>
